import AppIcon from 'components/common/AppIcon/AppIcon';
import Button from 'components/common/Button';
import TextInput from 'components/common/TextInput';
import uiHelper from 'helpers/uiHelper';
import PropTypes from 'prop-types';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import styled from 'styled-components';
import { colors, containerStyles } from 'styles/shared';




const ApiContainer = styled.div`
  width: 54.4rem;
  height: 23rem;
  padding: 3.5rem 4.5rem 4.8rem;
  margin-right: 5rem;
  margin-bottom: 5rem;
  ${containerStyles};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 3.5rem;
`;

const SettingsIcon = styled.div`
  width: 5rem;
  height: 5rem;
  background: ${colors.purple_lighter};
  opacity: 0.6;
  border-radius: 8.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 2rem;
`;

const HeaderTitle = styled.div`
  font-size: 3.2rem;
  line-height: 3.8rem;
  color: ${colors.darkBlue_darker};
`;

const Body = styled.div`
  display: flex;
`;

const DisabledTextInput = styled(TextInput)`
  width: 100%;
  height: auto;

  .form-control {
    width: 100%;
    background: ${colors.blue_lighter};
  }
`;

const CopyButton = styled(Button)`
  margin: 0 1.5rem;
`;

const RequestsContainer = styled.div`
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: ${colors.darkBlue_light};
  width: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

ApiSection.propTypes = {
  apiKey: PropTypes.string.isRequired,
  trial: PropTypes.bool,
  requests: PropTypes.number.isRequired
};

function ApiSection({apiKey, trial, requests}) {
  function onCopy() {
    uiHelper.showMessage('Copied to clipboard');
  }

  function render() {
    return (
      <ApiContainer>
        <Header>
          <SettingsIcon>
            <AppIcon name="settings" />
          </SettingsIcon>

          {trial ? (
                <HeaderTitle>Your Trial API key</HeaderTitle>
              ) : (
                <HeaderTitle>Your API key</HeaderTitle>
              )}
        </Header>

        <Body>
          <DisabledTextInput
            name="apiKey"
            value={apiKey}
            onChange={() => null}
            placeholder="Enter API key"
            error={null}
            disabled={true}
          />

          <CopyToClipboard text={apiKey} onCopy={onCopy}>
            <CopyButton isActive={apiKey ? true : false} width={5} onClick={() => null}>
              <AppIcon name="copy" color={colors.blue_darker} />
            </CopyButton>
          </CopyToClipboard>

          <RequestsContainer>/{requests}</RequestsContainer>
        </Body>
      </ApiContainer>
    );
  }

  return render();
}

export default ApiSection;
